import { axiosInstance } from "@/configs/axiosConfig";

export const getContactSearchAPIData = (apiParams) => {
  return axiosInstance.get("contactsearch", {
    params: apiParams,
  });
};

export const getContactProfileData = (path: { path: string }) => {
  return axiosInstance.get("contactprofile", {
    params: path,
  });
};

export const getContactIndustrySearchData = (params) => {
  return axiosInstance.post("contactcrawl", params);
};

export const getContactIndustryLocationData = (params) => {
  return axiosInstance.post("contactcrawllocation", params);
};
